import React, { useEffect } from 'react';
import Modal from 'react-modal';
import HelpContent from './HelpContent';

const HelpModal = (props) => {
  const body = document.getElementsByTagName("body")[0];

  return (
    <Modal
      isOpen
      appElement={body}
      shouldCloseOnOverlayClick={false}
      contentLabel={i18n.t('selection')}
      className="modal fade in help-dialog">

      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <button className="close" onClick={props.closeModal}>
              <span>×</span>
            </button>
            <h2>{ i18n.t('help.title') }</h2>
          </div>
          <div className="modal-body">
            <HelpContent />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default HelpModal

